
export class JZUser {
  id: string;
  userName: string;
  name: string;
  email: string;
  phoneNumber: string;
}
